import './MediaPlaceholder.css';

function MediaPlaceholder({ label, color = 'var(--orange)', corner, className = '' }) {
  return (
    <div
      className={`media-placeholder ${className}`}
      style={{ '--ph-color': color }}
    >
      <div className="media-placeholder-pattern" />
      <span className="media-placeholder-label">{label}</span>
      {corner && <div className="media-placeholder-corner">{corner}</div>}
    </div>
  );
}

export default MediaPlaceholder;
